import { RequestModelInterface } from "@/service/models/request-model-interface";
import { ResponseModelInterfaceStatic } from "@/service/models/response-model-interface";
import { staticImplements } from "@/utilities/static-implements";
import { XmlDocumentWrapper } from "@/utilities/xml-helpers/xml-document-wrapper";
import { XmlElementWrapper } from "@/utilities/xml-helpers/xml-element-wrapper";
import { BaseDosageChoice } from "../dosage-choices";

@staticImplements<ResponseModelInterfaceStatic>()
export class DosageSteadyState implements RequestModelInterface
{
    public constructor(
        public lastDoseDate: Date,
        public dosageChoice: BaseDosageChoice,
    )
    {
    }

    public getClosestNextDoseDate(knownDose: Date, current: Date): Date
    {
        return this.dosageChoice.getClosestNextDoseDate(knownDose, current);
    }

    public getClosestPreviousDoseDate(knownDose: Date, current: Date): Date
    {
        return this.dosageChoice.getClosestPreviousDoseDate(knownDose, current);
    }

    public static makeFromXml(elem: XmlElementWrapper): DosageSteadyState
    {
        return new this(
            elem.firstChildByTag("lastDoseDate").valueAsDate(),
            BaseDosageChoice.makeFromXmlGeneric(elem.firstChildWithTagIn(BaseDosageChoice.allowedTagNames))
        );
    }

    public getXml(doc: XmlDocumentWrapper): XmlElementWrapper
    {
        const element = doc.createElement("dosageSteadyState");

        element.appendNewElement("lastDoseDate", this.lastDoseDate.toISOString());
        element.append(this.dosageChoice.getXml(doc));

        return element;
    }
}
